import { Component, OnInit, ChangeDetectionStrategy, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { TenantModel } from '@core/models/auth/tenant.model';

@Component({
  selector: 'app-switch-tenant',
  templateUrl: './switch-tenant.component.html',
  styleUrls: ['./switch-tenant.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SwitchTenantComponent implements OnInit {
  @Input() tenants: TenantModel[];
  @Input() currentTenant: TenantModel;
  @Input() theme: string;
  @Output() tenantSelectionChanged = new EventEmitter<TenantModel>();

  constructor() { }

  ngOnInit() {
    if (this.tenants) {
      this.tenants.sort(this.compare);
    }
  }

  compare(a, b) {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();

    let comparison = 0;
    if (nameA > nameB) {
      comparison = 1;
    } else if (nameA < nameB) {
      comparison = -1;
    }
    return comparison;
  }

  switchTenant(tenant: TenantModel) {
    this.tenantSelectionChanged.emit(tenant);
  }
}
